module.exports = {
        srcSet: "/_next/static/images/up-arrow@3x-50-08df61657ada5aa3.png"+" 50w"+","+"/_next/static/images/up-arrow@3x-100-ac0b24c1621fa26b.png"+" 100w"+","+"/_next/static/images/up-arrow@3x-150-25aa8d5c3fcf975f.png"+" 150w",
        images: [{path: "/_next/static/images/up-arrow@3x-50-08df61657ada5aa3.png",width: 50,height: 50},{path: "/_next/static/images/up-arrow@3x-100-ac0b24c1621fa26b.png",width: 100,height: 100},{path: "/_next/static/images/up-arrow@3x-150-25aa8d5c3fcf975f.png",width: 150,height: 150}],
        src: "/_next/static/images/up-arrow@3x-150-25aa8d5c3fcf975f.png",
        toString: function(){return "/_next/static/images/up-arrow@3x-150-25aa8d5c3fcf975f.png"},
        
        width: 150,
        height: 150
      }